export enum ScaleTypeVerified {
  Qn = "Quantitative",
  Qt = "Qualitative",
  Txt = "Text",
}
